"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
const DeclinedEDS = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "max-width-600 min-height-600 mar-auto flex-center pad-20 align-start-touch", children: (0, jsx_runtime_1.jsx)(components_1.H3, { children: "Thank you for your interest. Unfortunately, we were unable to match you with a financing product. You can attempt again in 30 days." }) }));
};
exports.default = DeclinedEDS;
